import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DialogsModule } from '@progress/kendo-angular-dialog';

/**
 * Small confirm dialog for accepting an identity risk. Captures an optional audit
 * note; a blank note is defaulted by the caller to "Accepted without justification".
 * Reused for single-entity, Accept All, and tenant-level acceptance.
 */
@Component({
  selector: 'app-accept-reason-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule, DialogsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <kendo-dialog [title]="title()" (close)="cancel.emit()" [width]="460" [minWidth]="320">
      <p class="text-muted small mb-2">{{ subtitle() }}</p>
      <label class="form-label small fw-medium mb-1" for="accept-reason">Reason (optional)</label>
      <textarea
        id="accept-reason"
        class="form-control"
        rows="3"
        [(ngModel)]="reason"
        placeholder="Add a short justification for the audit trail (e.g. break-glass account, compensating control in place)."
      ></textarea>
      <kendo-dialog-actions>
        <button class="btn btn-outline-secondary btn-sm" (click)="cancel.emit()">Cancel</button>
        <button class="btn btn-primary btn-sm" (click)="confirm.emit(reason.trim())">Accept Risk</button>
      </kendo-dialog-actions>
    </kendo-dialog>
  `,
})
export class AcceptReasonDialogComponent {
  title = input<string>('Accept this risk');
  subtitle = input<string>(
    'Accepting marks this as a known, acknowledged risk. It is no longer counted against your score.'
  );
  cancel = output<void>();
  /** Emits the trimmed reason (may be empty; the caller applies the default text). */
  confirm = output<string>();

  protected reason = '';
}
